import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "layout-calendar stlye-home-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("ul", { class: "layout-sub" }, [
  /*#__PURE__*/_createElementVNode("li", null, "一"),
  /*#__PURE__*/_createElementVNode("li", null, "二"),
  /*#__PURE__*/_createElementVNode("li", null, "三"),
  /*#__PURE__*/_createElementVNode("li", null, "四"),
  /*#__PURE__*/_createElementVNode("li", null, "五"),
  /*#__PURE__*/_createElementVNode("li", null, "六"),
  /*#__PURE__*/_createElementVNode("li", null, "日")
], -1)
const _hoisted_3 = { class: "layout-activity-list stlye-home-card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "layout-head" }, " 正在进行的活动: ", -1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "date" }

import { NCalendar } from "naive-ui";
import { useCalendar } from '@/composables/useCalendar'



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let { value, list, getDate } = useCalendar()

function navigate(OutLink: string) {
  window.open(OutLink)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_unref(NCalendar), {
        "default-value": new Date().getTime(),
        value: _unref(value),
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : value = $event))
      }, null, 8, ["default-value", "value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list).data, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            onClick: ($event: any) => (navigate(item.link))
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(item.title), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getDate)(item.date)), 1)
          ], 8, _hoisted_5))
        }), 128))
      ])
    ])
  ], 64))
}
}

})